import { useState } from "react";
import {  SvgIcon, IconButton } from "@mui/material";
import _ from "lodash";
import { EventRepeat as RepeatIcon } from "@mui/icons-material";
import Repeater from "../prescriptions/table-list/Repeater";
import { useAuth } from "../../auth/context";

const RepeaterButton = ({ medicalDocument, backPath }) => {
  const [repeaterOpen, setRepeaterOpen] = useState(false);
  const toggleRepeater = () => setRepeaterOpen((repeaterOpen) => !repeaterOpen);
  const { user } = useAuth();

  if (!user.canRepeat(medicalDocument)) return;

  return (
    <>
      <IconButton sx={{ ml: 1 }} onClick={toggleRepeater}>
        <SvgIcon sx={{ color: "primary.main", fontSize: 25 }}>
          <RepeatIcon />
        </SvgIcon>
      </IconButton>
      <Repeater
        medicalDocument={medicalDocument}
        onClose={toggleRepeater}
        repeaterOpen={repeaterOpen}
        backPath={backPath}
      />
    </>
  );
};

export default RepeaterButton;